import {useEffect, useState, useCallback} from "react";
import {GET_SELECTED_SHOP_ID, REQUEST} from "../../../../utils/js/Const";
import {FetchElements, GetCookie} from "../../../../utils/js/request";
import {useNavigate} from "react-router-dom";

export const useOrderGroups = () => {
    const navigate = useNavigate();

    const [orderGroups, setOrderGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchOrderGroups = useCallback(() => {
        const selectedId = GET_SELECTED_SHOP_ID();
        const accessToken = GetCookie("access_token");

        if (!selectedId || !accessToken) {
            console.warn('Нет данных для запроса групп заказов');
            setOrderGroups([]);
            return;
        }

        const url = `${REQUEST}/api/v1/orders?shops_id=${selectedId}`;
        setLoading(true);
        setError(null);

        FetchElements(
            url,
            "GET",
            (responseData) => {
                const groups = responseData?.data || responseData || [];
                setOrderGroups(Array.isArray(groups) ? groups : []);
                setLoading(false);
            },
            navigate,
            2,
            () => {},
            (title, message, statusCode) => {
                const errorObj = {title, message, statusCode};
                console.error(`${title}: ${message}`);
                setError(errorObj);
                setLoading(false);
            },
            0,
            null,
            [],
            false
        );
    }, [navigate]);

    useEffect(() => {
        fetchOrderGroups();
    }, [fetchOrderGroups]);

    return {
        orderGroups,
        loading,
        error,
        refetch: fetchOrderGroups,
    };
};